import React from 'react';
import { PEIImage, PEILink } from '@/common/components';
import styles from '@/styles/Headline.module.scss';
import { StaticImageData } from 'next/image';
import { parseText } from '@/utils';
import { defaultImagePath } from '@/common';

type props = {
  imageURL: string | StaticImageData;
  headingText: string;
  contentText: string;
  link: string;
};
export const HeadLineItems = ({ imageURL, headingText, contentText, link }: props) => {
  const defImageStyle = `${styles.imageStyle} ${styles.staticImageGalleryStyle}`;
  return (
    <div className={styles.galleryItems}>
      <PEIImage
        src={imageURL}
        alt='Picture of the Company'
        height={250}
        width={250}
        className={styles.imageStyle}
        onClick={() => {
          window.open(link);
        }}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = defaultImagePath;
        }}
      />
      <PEILink href={link} target='_blank' className={styles.heroItemContentLink}>
        <h3 className={styles.heroItemContentText}>{parseText(headingText)}</h3>
      </PEILink>
      <p className={styles.headlineItemsContent}>{parseText(contentText)}</p>
    </div>
  );
};
